package com.example.hukakmp.draft

import kotlinx.browser.window

private fun draftKey(uid: String) = "huka_report_draft_v1_$uid"

actual object ReportDraftPersistence {
    actual fun load(uid: String): String? =
        window.localStorage.getItem(draftKey(uid))

    actual fun save(uid: String, value: String) {
        window.localStorage.setItem(draftKey(uid), value)
    }

    actual fun clear(uid: String) {
        window.localStorage.removeItem(draftKey(uid))
    }
}
